import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Subnav from 'components/Subnav';
import EnterpriseContext from '../../providers/Enterprise/Enterprise.context';
import { getEnterpriseRoute } from 'utils';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

import './RwcEnterpriseNavigation.styles.scss';

type RwcEnterpriseNavigationProps = {
  className?: string;
};

const RwcEnterpriseNavigation: React.FC<RwcEnterpriseNavigationProps> = (
  props,
) => {
  const { className } = props;

  const classes = classNames('rwc-enterprise-navigation', className);

  const { t } = useTranslation();

  const { isOfficeManager } = useContext(CurrentUserContext);
  const {
    enterprise: { _id, isDemo },
  } = useContext(EnterpriseContext);

  const routerHomeLink = useMemo(
    () => ({
      to: getEnterpriseRoute(true, isDemo, _id),
      label: t('overview'),
    }),
    [_id, isDemo, t],
  );

  const links = useMemo(
    () => [
      {
        to: `${getEnterpriseRoute(true, isDemo, _id)}/configuration`,
        label: t('configuration'),
      },
      ...(isOfficeManager
        ? []
        : [
            {
              to: `${getEnterpriseRoute(true, isDemo, _id)}/branding`,
              label: t('branding'),
            },
          ]),
    ],
    [_id, isDemo, isOfficeManager, t],
  );

  return (
    <Subnav routerHomeLink={routerHomeLink} links={links} className={classes} />
  );
};

export default RwcEnterpriseNavigation;
